import React from 'react'
import {Link} from 'react-router'
import styles from './Card.scss'
import cx from 'classnames'
import {userIsAdmin} from 'lib/utils'
import {logErrorBoundActivation} from 'lib/sentry'

export class Card extends React.PureComponent {
  state = {error: null}

  componentDidCatch (error, errorInfo) {
    this.setState({error})
    // see https://sentry.io/ridewithgpscom/rwgps-ui/getting-started/javascript-react/
    // for a full explanation
    logErrorBoundActivation(error, errorInfo)
  }

  render () {
    const {error} = this.state
    const {href, to, noPadding, noMargin, className, children, ...props} = this.props
    const cn = cx(
      styles.Card,
      className,
      (href || to) && styles.clickable,
      noMargin && styles.noMargin,
      noPadding && styles.noPadding
    )

    if (error) {
      return (
        <div data-interface-spacing {...props} className={styles.Card}>
          <p>We encountered an error while loading this item.</p>
          <p>Please reload the page and try again. If you continue to experience this error, please <a href='https://ridewithgps.zendesk.com/hc/en-us/requests/new' target='_blank'>let us know</a>.</p>
          {userIsAdmin && <p data-tip title='this stack trace is only visible to admins'>
            <pre style={{overflowX: 'auto'}}><code>
              {error.stack}
            </code></pre>
          </p>}
        </div>
      )
    }

    if (href) {
      return (
        <a href={href} {...props} className={cn}>
          {children}
        </a>
      )
    }

    if (to) {
      return (
        <Link to={to} {...props} className={cn}>
          {children}
        </Link>
      )
    }

    return (
      <div {...props} className={cn}>
        {children}
      </div>
    )
  }
}
